import MenuIcon from "@mui/icons-material/Menu";
import { AppBar, Box, IconButton, Toolbar } from "@mui/material";
import KinternLogo from "../../../components/internal/KinternLogo";

interface InternMobileHeaderProps {
  onMenuClick: () => void;
}

const InternMobileHeader = ({ onMenuClick }: InternMobileHeaderProps) => {
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        display: { xs: "block", md: "none" },
        bgcolor: "var(--intern-bg-primary)",
        borderBottom: "1px solid var(--intern-border-default)",
      }}
    >
      <Toolbar
        sx={{
          minHeight: 56,
          px: 2,
          justifyContent: "space-between",
        }}
      >
        {/* Logo on left */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            "& svg path": {
              fill: "var(--intern-text-primary)",
            },
          }}
        >
          <KinternLogo height="20px" />
        </Box>

        {/* Hamburger on right */}
        <IconButton
          edge="end"
          onClick={onMenuClick}
          sx={{
            color: "var(--intern-text-primary)",
          }}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default InternMobileHeader;
